import { NgModule } from '@angular/core';
import { NbCardModule } from '@nebular/theme';
import { ChartModule } from 'angular2-chartjs';
@NgModule({
  imports: [ChartModule, NbCardModule],
  exports: [ChartModule, NbCardModule],
  declarations: []
})
export class ChartsModule {}
